module.exports = __webpack_public_path__ + "static/img/saledefalute.133eaac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/saledefalute.jpg
// module id = qVCy
// module chunks = 158